<template>
  <div>
    <SnackbarComp :SnackbarComponent="SnackbarComponent" />
    <v-dialog
      class="poll-card"
      persistent
      elevation="0"
      v-model="dialog"
      width="400"
    >
      <div>
        <v-card class="pa-4 rounded-xl text-center" elevation="4">
          <v-card-text class="pt-6 pb-2">
            <v-avatar
              :color="poll.poll_status === 'LIVE' ? 'warning' : 'error'"
              variant="tonal"
              size="80"
              class="mb-4"
            >
              <v-icon
                :icon="
                  poll.poll_status === 'LIVE'
                    ? 'mdi-alert-octagon-outline'
                    : 'mdi-trash-can-outline'
                "
                size="45"
              ></v-icon>
            </v-avatar>

            <h3 class="text-h5 font-weight-bold mb-2 text-grey-darken-4">
              {{ poll.poll_status === "LIVE" ? "Abort Poll?" : "Delete Poll?" }}
            </h3>

            <p class="text-body-1 text-grey-darken-1 mb-2">
              Are you sure you want to
              <strong
                :class="
                  poll.poll_status === 'LIVE' ? 'text-warning' : 'text-error'
                "
              >
                {{ poll.poll_status === "LIVE" ? "abort" : "delete" }}
              </strong>
              this poll? This action cannot be undone.
            </p>
          </v-card-text>

          <v-card-actions class="d-flex justify-center pb-4 pt-0">
            <v-btn
              variant="tonal"
              color="grey-darken-2"
              class="px-6 mx-2 text-none font-weight-bold"
              rounded="lg"
              @click="closeDialog"
            >
              Cancel
            </v-btn>

            <v-btn
              :color="poll.poll_status === 'LIVE' ? 'warning' : 'error'"
              variant="flat"
              class="px-6 mx-2 text-none font-weight-bold shadow-sm"
              rounded="lg"
              :loading="loading"
              @click="confirmAction"
            >
              Yes, {{ poll.poll_status === "LIVE" ? "Abort" : "Delete" }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import { deleteOrDeactivatePoll } from "@/graphql/mutations";
import SnackbarComp from "@/components/Extras/SnackbarComp.vue";
import { generateClient } from "aws-amplify/api";
const client = generateClient();
export default {
  name: "ActivateDeactivatePollDialog",
  props: {
    activateDeactivatePollDialog: {
      type: Boolean,
      required: true,
    },
    poll: {
      type: Object,
      required: true,
    },
  },
  components: {
    SnackbarComp,
  },
  data() {
    return {
      dialog: false,
      loading: false,
      SnackbarComponent: {
        SnackbarVmodel: false,
        SnackbarText: "",
        SnackbarColor: "success",
      },
    };
  },
  watch: {
    activateDeactivatePollDialog(newVal) {
      this.dialog = newVal;
    },
  },
  methods: {
    closeDialog() {
      this.$emit("update", false);
    },
    async confirmAction() {
      try {
        this.loading = true;
        let result = await client.graphql({
          query: deleteOrDeactivatePoll,
          variables: {
            input: {
              user_id: this.$store.getters.get_current_user_details.user_id,
              pollId: this.poll.pollId,
              action_type:
                this.poll.poll_status === "LIVE" ? "ABORT" : "DELETE",
            },
          },
        });

        var ResultObj = JSON.parse(result.data.deleteOrDeactivatePoll);
        if (ResultObj.status == 200 || ResultObj.status === "SUCCESS") {
          this.SnackbarComponent.SnackbarText = `Poll ${
            this.poll.poll_status === "LIVE" ? "aborted" : "deleted"
          } successfully.`;
          this.SnackbarComponent.SnackbarColor = "success";
          this.SnackbarComponent.SnackbarVmodel = true;
          this.$emit("update", 2);
        }
      } catch (error) {
        console.error("Error:", error);
        this.SnackbarComponent.SnackbarText =
          "An error occurred. Please try again.";
        this.SnackbarComponent.SnackbarColor = "error";
        this.SnackbarComponent.SnackbarVmodel = true;
        this.$emit("update", false);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.poll-card {
  border-radius: 12px;
  transition: 0.2s ease;
}
</style>
